import React from 'react'

import { Button } from '@driftt/dds'
import {
  Div,
  Footer,
  H3,
  Modal,
  P 
} from '@driftt/tide-core'

const EnrollSegmentSuccessModal = ({
  open,
  onClose,
  goToPlaybook 
}) => (
  <Modal
    open={open}
    onClose={onClose}
    size="small"
  >
    <Div className="add-segment-to-pb-success-modal">
      <H3>Successfully added segment to the playbook audience</H3>
      <P type="subtle">View your playbook in the editor to see changes</P>
      <Footer>
        <Button onClick={goToPlaybook}>View playbook audience</Button>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
      </Footer>
    </Div>
  </Modal>
)

export default EnrollSegmentSuccessModal
